import { SensorPortCommunicationMode } from "../../../portConfigs.js";
import { SensorClusterConfig } from "../types.js";

type TempHumClusterArgs = {
    modelName: string;
    friendlyName: string;
    friendlyShortName: string;
};

function makeTempHumCluster({
    modelName,
    friendlyName,
    friendlyShortName,
}: TempHumClusterArgs): SensorClusterConfig<Record<string, never>> {
    return {
        communicationMode: SensorPortCommunicationMode.DIGITAL,
        requiredSubChannels: [],
        optionalSubChannels: [],
        isPermanentlyAttached: true,
        parameterConfigs: {},
        manufacturerName: "Verdi",
        modelName,
        friendlyName,
        friendlyShortName,
        generateSensorElements: () => [
            {
                sensorElementConfigKey: "boardTemperature",
                parameters: {},
                legalConvertedRange: [-50, 100] as [number, number],
                subChannel: 0,
            },
            {
                sensorElementConfigKey: "humidity",
                parameters: {},
                legalConvertedRange: [0, 100] as [number, number],
                subChannel: 1,
            },
        ],
    };
}

export const tempHumClusterConfigs: Record<string, SensorClusterConfig<Record<string, never>>> = {
    Gen4_TempHum: makeTempHumCluster({
        modelName: "Gen4 Onboard Temp/Hum",
        friendlyName: "Onboard Temp & Humidity",
        friendlyShortName: "Temp/Hum",
    }),

    Sprout_TempHum: makeTempHumCluster({
        modelName: "Sprout Onboard Temp/Hum",
        friendlyName: "Onboard Temp & Humidity",
        friendlyShortName: "Temp/Hum",
    }),

    SeedSap_TempHum: makeTempHumCluster({
        modelName: "Seed/Sapling Onboard Temp/Hum",
        friendlyName: "Onboard Temp & Humidity",
        friendlyShortName: "Temp/Hum",
    }),
};
